module.exports = __webpack_public_path__ + "img/spain-blood-diseases-female.106189ed.png";